import { defineComponent as N, useSlots as Y, computed as i, openBlock as c, createBlock as p, unref as q, normalizeClass as O, createSlots as Z, withCtx as _, createTextVNode as J, toDisplayString as G, renderSlot as K, createElementBlock as y, normalizeStyle as ee, createCommentVNode as f, mergeProps as D, resolveDynamicComponent as R, createElementVNode as E, normalizeProps as te, guardReactiveProps as ne, Fragment as ae, renderList as oe } from "vue";
import { CdrButton as re, CdrLink as le } from "@rei/cedar";
import { CdrColorTextSecondary as w, CdrColorTextPrimary as A, CdrColorTextLinkRest as v, CdrColorTextBrand as B, CdrColorTextInverse as o, CdrColorTextSale as z, CdrColorBackgroundPrimary as ie, CdrColorBackgroundSecondary as ce, CdrColorBackgroundMessageSale as se, CdrColorBackgroundBrandSpruce as de } from "@rei/cdr-tokens";
import ue from "@rei/landing-image-component-deprecated";
import fe from "@rei/landing-image-component";
const V = {
  contentPalettes: {
    primary: {
      eyebrow: w,
      heading: A,
      subheading: A,
      body: w,
      inlineLink: v,
      accentText: B,
      altLink: v,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    inverse: {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "dark-secondary"
    },
    sale: {
      eyebrow: A,
      heading: z,
      subheading: z,
      body: A,
      inlineLink: v,
      accentText: z,
      altLink: v,
      primaryCtaModifier: "sale",
      secondaryCtaModifier: "secondary"
    },
    "sale-inverse": {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "sale"
    },
    brand: {
      eyebrow: w,
      heading: B,
      subheading: B,
      body: w,
      inlineLink: v,
      accentText: B,
      altLink: v,
      primaryCtaModifier: "primary",
      secondaryCtaModifier: "secondary"
    },
    "brand-inverse": {
      eyebrow: o,
      heading: o,
      subheading: o,
      body: o,
      inlineLink: o,
      accentText: o,
      altLink: o,
      primaryCtaModifier: "secondary",
      secondaryCtaModifier: "inverse-secondary"
    }
  },
  surfacePalettes: {
    primary: {
      background: ie
    },
    secondary: {
      background: ce
    },
    sale: {
      background: se
    },
    brand: {
      background: de
    },
    dark: {
      background: "#0c0b08bf"
    }
  }
}, ye = (a = { content: "primary", surface: "primary" }) => ({
  cssSurfacePaletteVars: () => {
    const t = V.surfacePalettes[a.surface];
    return {
      "--palette-background-color": t == null ? void 0 : t.background
    };
  },
  /*
  * These can be imported for sections that dont use content block but still need
  * content palette applied.
  */
  paletteCtaModifiers: () => {
    const t = V.contentPalettes[a.content];
    return {
      primaryCtaModifier: t.primaryCtaModifier,
      secondaryCtaModifier: t.secondaryCtaModifier
    };
  },
  cssContentPaletteVars: () => {
    const t = V.contentPalettes[a.content];
    return {
      "--palette-eyebrow-color": t == null ? void 0 : t.eyebrow,
      "--palette-heading-color": t == null ? void 0 : t.heading,
      "--palette-subheading-color": t == null ? void 0 : t.subheading,
      "--palette-body-color": t == null ? void 0 : t.body,
      "--palette-inline-link-color": t == null ? void 0 : t.inlineLink,
      "--palette-accent-text-color": t == null ? void 0 : t.accentText,
      "--palette-alt-link-color": t == null ? void 0 : t.altLink
    };
  }
}), ge = /* @__PURE__ */ N({
  __name: "LandingAction",
  props: {
    modifier: {
      type: String,
      required: !1,
      default: "primary"
    },
    href: {
      type: String,
      required: !1,
      default: ""
    },
    target: {
      type: String,
      required: !1,
      default: ""
    },
    newTab: {
      type: Boolean,
      required: !1,
      default: !1
    },
    tag: {
      type: String,
      required: !1,
      default: "a"
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    noFollow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    analyticsId: {
      type: String,
      required: !1,
      default: ""
    },
    ariaLabel: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(a) {
    const t = ["inverse-secondary", "dark-secondary"], n = Y(), m = (g) => !!n[g], s = a, C = i(() => s.ariaLabel ? s.ariaLabel : s.text), x = i(() => m("landing-action-icon")), k = i(() => s.modifier && !t.includes(s.modifier) ? s.modifier : void 0), P = i(() => `ls-content-block__action ${t.includes(s.modifier) ? `ls-content-block__action--${s.modifier} ` : ""}`);
    return (g, $) => (c(), p(q(re), {
      class: O(P.value),
      modifier: k.value,
      href: a.href || a.target,
      target: a.newTab ? "_blank" : null,
      tag: a.tag || "a",
      rel: a.noFollow ? "nofollow" : null,
      "data-analytics-id": a.analyticsId,
      "aria-label": C.value
    }, Z({
      default: _(() => [J(" " + G(a.text), 1)]),
      _: 2
    }, [x.value ? {
      name: "icon-left",
      fn: _(() => [K(g.$slots, "landing-action-icon", {}, void 0, !0)]),
      key: "0"
    } : void 0]), 1032, ["class", "modifier", "href", "target", "tag", "rel", "data-analytics-id", "aria-label"]));
  }
});
const Q = (a, t) => {
  const n = a.__vccOpts || a;
  for (const [m, s] of t)
    n[m] = s;
  return n;
}, be = /* @__PURE__ */ Q(ge, [["__scopeId", "data-v-6f9ccc66"]]), pe = {
  key: 0,
  class: "ls-content-block__region ls-content-block__region--top"
}, me = ["innerHTML"], ke = {
  key: 1,
  class: "ls-content-block__region ls-content-block__region--middle"
}, ve = ["innerHTML"], _e = ["innerHTML"], he = ["innerHTML"], Ce = {
  key: 2,
  class: "ls-content-block__region ls-content-block__region--bottom"
}, xe = {
  key: 0,
  class: "ls-content-block__actions-container"
}, Le = /* @__PURE__ */ N({
  __name: "LandingContentBlock",
  props: {
    lockup: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    eyebrow: {
      type: String,
      required: !1,
      default: ""
    },
    heading: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    subheading: {
      type: String,
      required: !1,
      default: ""
    },
    body: {
      type: String,
      required: !1,
      default: ""
    },
    actions: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    config: {
      type: Object,
      required: !1,
      default: () => {
      }
    }
  },
  setup(a) {
    const t = {
      level: "h2",
      size: "md-standard",
      srOnly: !1
    }, n = a, m = (e, l) => {
      const r = {}, u = ["xs", "sm", "md", "lg"];
      return u.forEach((b, M) => {
        r[`--${e}-${b}`] = l[b] || r[`--${e}-${[u[M - 1]]}`];
      }), r;
    }, s = (e) => {
      switch (e) {
        case "left":
          return "flex-start";
        case "right":
          return "flex-end";
        default:
          return "center";
      }
    }, C = i(() => !!(n.lockup && n.lockup.images)), x = i(() => !!(n.lockup && (n.lockup.src || n.lockup.xs))), k = i(() => {
      var l, r;
      const e = ((r = (l = n.config) == null ? void 0 : l.palette) == null ? void 0 : r.content) || "primary";
      return ye({
        content: e
      });
    }), P = i(() => {
      const {
        contentAlign: e = {}
      } = n.config || {}, l = {};
      Object.keys(e).forEach((S) => {
        const T = e[S] || "left";
        l[S] = s(T);
      });
      const r = m("content-align", l), u = m("text-align", e), b = k == null ? void 0 : k.value.cssContentPaletteVars();
      return {
        ...r,
        ...u,
        ...b
      };
    }), g = i(() => {
      var e, l, r, u;
      return !!((l = (e = n.actions) == null ? void 0 : e.defaultActions) != null && l.length) || !!((u = (r = n.actions) == null ? void 0 : r.javascriptActions) != null && u.length);
    }), $ = i(() => {
      var T;
      const {
        javascriptActions: e = [],
        defaultActions: l = []
      } = n.actions, {
        primaryCtaModifier: r,
        secondaryCtaModifier: u
      } = k.value.paletteCtaModifiers(), b = (T = n.actions) == null ? void 0 : T.allSecondaryButtons, M = e == null ? void 0 : e.map((H, I) => {
        const h = {
          ...H
        };
        return h.modifier = I === 0 && !b ? r : u, h;
      }), S = l.map((H, I) => {
        const h = {
          ...H
        };
        return h.modifier = I === 0 && !b && !(e != null && e.length) ? r : u, h;
      });
      return {
        javascriptActions: M,
        defaultActions: S
      };
    }), L = i(() => {
      const {
        alternateLink: e
      } = n.actions || {};
      return (e == null ? void 0 : e.href) && (e == null ? void 0 : e.text) ? e : null;
    }), d = i(() => ({
      ...t,
      ...n.heading
    })), j = i(() => {
      let e;
      const l = ["h2", "h3", "h4", "h5", "h6"];
      if (!d.value.text)
        e = d.value.level;
      else if (d.value.level) {
        const r = l.indexOf(d.value.level);
        e = r < 3 ? l[r + 1] : "span";
      }
      return {
        level: e || t.level,
        text: n.subheading
      };
    }), F = i(() => d.value.srOnly ? "true" : "false"), U = i(() => !!C.value || !!x.value || !!n.eyebrow), W = i(() => {
      var e;
      return !!((e = n == null ? void 0 : n.heading) != null && e.text) || !!n.subheading || !!n.body;
    }), X = i(() => !!g.value || !!L.value);
    return (e, l) => (c(), y("div", {
      style: ee(P.value),
      class: O(["ls-content-block", `ls-content-block--${d.value.size || "md"}`])
    }, [U.value ? (c(), y("div", pe, [x.value ? (c(), p(q(ue), {
      key: 0,
      class: "ls-content-block__lockup",
      media: a.lockup,
      "aria-hidden": F.value
    }, null, 8, ["media", "aria-hidden"])) : f("", !0), C.value ? (c(), p(q(fe), D({
      key: 1,
      class: "ls-content-block__lockup"
    }, a.lockup, {
      "aria-hidden": F.value
    }), null, 16, ["aria-hidden"])) : f("", !0), a.eyebrow ? (c(), y("div", {
      key: 2,
      class: "ls-content-block__eyebrow",
      innerHTML: a.eyebrow
    }, null, 8, me)) : f("", !0)])) : f("", !0), W.value ? (c(), y("div", ke, [d.value.text ? (c(), p(R(d.value.level), {
      key: 0,
      class: O(["ls-content-block__heading", `ls-content-block__heading--${d.value.size || "md-standard"}`, {
        "ls-content-block__heading--sr-only": d.value.srOnly
      }])
    }, {
      default: _(() => [E("span", {
        innerHTML: d.value.text
      }, null, 8, ve)]),
      _: 1
    }, 8, ["class"])) : f("", !0), j.value.text ? (c(), p(R(j.value.level), {
      key: 1,
      class: O(["ls-content-block__subheading", `ls-content-block__subheading--has-heading-${d.value.size || "md"}`])
    }, {
      default: _(() => [E("span", {
        innerHTML: j.value.text
      }, null, 8, _e)]),
      _: 1
    }, 8, ["class"])) : f("", !0), a.body ? (c(), y("div", {
      key: 2,
      class: "ls-content-block__body",
      innerHTML: a.body
    }, null, 8, he)) : f("", !0)])) : f("", !0), X.value ? (c(), y("div", Ce, [g.value ? (c(), y("div", xe, [K(e.$slots, "javascriptActions", te(ne({
      javascriptActions: $.value.javascriptActions
    })), void 0, !0), (c(!0), y(ae, null, oe($.value.defaultActions, (r, u) => (c(), p(be, D({
      key: u,
      ref_for: !0
    }, r), {
      "landing-action-icon": _(() => []),
      _: 2
    }, 1040))), 128))])) : f("", !0), L.value ? (c(), p(q(le), {
      key: 1,
      class: "ls-content-block__alternate-link",
      href: L.value.href,
      standalone: ""
    }, {
      default: _(() => [J(G(L.value.text), 1)]),
      _: 1
    }, 8, ["href"])) : f("", !0)])) : f("", !0)], 6));
  }
});
const Be = /* @__PURE__ */ Q(Le, [["__scopeId", "data-v-38b6985f"]]);
export {
  be as LandingAction,
  Be as LandingContentBlock
};
